import { motion } from "framer-motion";

const groups = [
  {
    title: "For business owners &amp; professionals",
    tag: "Business",
    intro: "People who personally manage a large number of business contacts.",
    items: [
      "Traders &amp; wholesalers",
      "Shop owners &amp; retailers",
      "Manufacturers",
      "Contractors &amp; local service providers",
      "Real-estate professionals",
      "Consultants &amp; salespeople",
      "Freelancers",
    ],
  },
  {
    title: "For everyone with a growing network",
    tag: "Personal",
    intro: "Anyone whose contact list has outgrown a plain phonebook.",
    items: [
      "Recruiters",
      "Insurance &amp; financial agents",
      "Students building a professional network",
      "Community organizers",
      "Field workers &amp; on-the-ground teams",
      "Frequent networkers &amp; conference-goers",
      "Anyone with a messy phonebook",
    ],
  },
];

export default function Solutions() {
  return (
    <section id="solutions" className="relative py-24 md:py-32 border-t border-black/5" data-testid="solutions-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-14">
          <div className="md:col-span-8">
            <div className="overline mb-4">Who it&apos;s for</div>
            <h2 className="font-display text-4xl md:text-6xl font-medium leading-[0.95] tracking-tight text-[color:var(--ink)]">
              If your phonebook feels
              <span className="gradient-text" style={{ fontFamily: "var(--font-serif)", fontStyle: "italic" }}>
                {" "}
                impossible to manage,
              </span>{" "}
              you&apos;re in the right place.
            </h2>
          </div>
          <p className="md:col-span-4 text-[color:var(--ink-soft)] text-base md:text-lg">
            Whether you run a business or simply have a lot of people to remember — BizBinder is built for you.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {groups.map((g, gi) => (
            <motion.div
              key={g.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: gi * 0.1 }}
              className="rounded-3xl border border-[color:var(--line)] p-8 md:p-10 bg-white shadow-sm"
              data-testid={`audience-${g.tag.toLowerCase()}`}
            >
              <div className="flex items-center gap-3 mb-6">
                <span
                  className="px-2.5 py-1 rounded-full text-[10px] font-medium tracking-widest uppercase"
                  style={{
                    background: gi === 0 ? "var(--accent-soft)" : "var(--blue-soft)",
                    color: gi === 0 ? "var(--accent)" : "var(--blue)",
                  }}
                >
                  {g.tag}
                </span>
              </div>
              <h3
                className="font-display text-3xl md:text-4xl font-medium text-[color:var(--ink)] leading-[1.05] tracking-tight"
                dangerouslySetInnerHTML={{ __html: g.title }}
              />
              <p className="mt-3 text-[color:var(--ink-soft)] text-sm max-w-md">{g.intro}</p>
              <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                {g.items.map((it, i) => (
                  <li key={it} className="flex items-start gap-3 text-[color:var(--ink)] text-sm">
                    <span
                      className="mt-1.5 w-1.5 h-1.5 rounded-full shrink-0"
                      style={{ background: gi === 0 ? "var(--accent)" : "var(--blue)" }}
                    />
                    <span dangerouslySetInnerHTML={{ __html: it }} />
                    <span className="ml-auto text-[color:var(--ink-mute)] text-xs font-mono">{String(i + 1).padStart(2, "0")}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
